import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import { Row, Col, ButtonToolbar, Button } from 'react-bootstrap';
import ReactDataGrid from 'react-data-grid';
import Spinner from '../../components/Widgets/spinner';
import ContentWrapper from '../Layout/ContentWrapper';
import NotifyModal from 'Common/notifyModal';

const { Selectors } = Data;

class TrackingNoteModal extends Component {

  constructor() {
    super();
    this.state = {
      selectedOrder: {
        order_num: null,
        id: null,
      },

      rows: [],
      selectedRows: null,
      editedRows: [],
      filters: {},
      sortColumn: null,
      sortDirection: null,

      notifyModalOpen: false,
    }
  }

  componentDidMount() {
    const { selectedOrder } = this.props;
    if (selectedOrder.length === 1) {
      this.setState({
        selectedOrder: this.props.selectedOrder[0]
      });
      this.props.fetchTrackingNote(selectedOrder[0].id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const PT = nextProps.notes;
    if (nextProps.notes && nextProps.notes != this.props.notes) {
      let notes = nextProps.notes;
      let index = 0;
      notes.map(note => {
        note.Idx = index++;
      })
      this.setState({
        rows: notes,
        selectedRows: null,
        editedRows: [],
      });
    }
  }

  // componentWillUnmount() { 
  //   }

  openNotifyModal = () => {
    this.setState({
      notifyModalOpen: true
    })
  }

  closeNotifyModal = () => {
    this.setState({
      notifyModalOpen: false
    })
  }

  clickNew(e) {
    e.preventDefault();
    let rows = Selectors.getRows(this.state);
    let index = rows.length;
    let newRow = { Product_SKU: null, Product_Name: null, Post_Date: null, Est_Delivery_Date: null, Quantity: null, Note: null, Idx: index };
    rows.push(newRow);
    let editedRows = [...this.state.editedRows];
    editedRows.push(newRow)
    this.setState({ rows, editedRows })
  }

  deleteCategory(e) {
    e.preventDefault();
    // let productSKU = this.state.selectedRows[0].productSKU;
    // if (productSKU) {
    //   this.props.deleteCategory(productSKU);
    // }
    // else {
    let rows = [...this.state.rows];
    let editedRows = [...this.state.editedRows];
    let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })
    rows.splice(index, 1);
    index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
    editedRows.splice(index, 1);
    this.setState({ rows, editedRows, selectedRows: [] })
    // }
  }

  updateRows(e) {
    const { selectedOrder } = this.props;
    // const computedRows = this.state.rows.map((row) => {
    //   const editedRow = this.state.editedRows.find(({ productSKU }) => productSKU === row.productSKU);
    //   if (editedRow !== undefined) {
    //     return editedRow;
    //   }
    //   return row;
    // });
    const computedRows = this.state.rows;
    e.preventDefault();
    this.props.editTrackingNote(selectedOrder[0].id, computedRows);
    this.openNotifyModal();
  }

  renderTrackingNoteTable() {

    const getRows = () => {
      return Selectors.getRows(this.state);
    }

    const getSize = () => {
      return getRows().length;
    }

    const rowGetter = rowIdx => {
      var rows = getRows();
      return rows[rowIdx];
    }

    const handleGridSort = (sortColumn, sortDirection) => {
      var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
      this.setState(state);
    }

    const handleFilterChange = filter => {
      let newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    }

    const handleRowUpdated = e => {
      this.setState({ sortColumn: null, sortDirection: null })
      let rows = getRows();
      let editedRows = this.state.editedRows.slice(0);
      Object.assign(rows[e.rowIdx], e.updated);
      editedRows.forEach((element, index) => {
        if (element.Idx === rows[e.rowIdx].Idx)
          editedRows.splice(index, 1)
      }, this);
      editedRows.push(rows[e.rowIdx]);
      this.setState({
        rows: rows,
        editedRows: editedRows
      });
    }

    const onRowsSelected = (rows) => {
      let newRows = getRows();
      newRows.map(r => {
        r.isSelected = false;
      })
      rows.map(r => {
        newRows[r.rowIdx].isSelected = true;
      });
      this.setState({ rows: newRows, selectedRows: [rows[0].row] });
    }

    const onRowsDeselected = (rows) => {
      let newRows = getRows();
      rows.map(r => {
        newRows[r.rowIdx].isSelected = false;
      });
      this.setState({ rows: newRows, selectedRows: [] });
    }

    const columns = [
      {
        key: 'Product_SKU',
        name: <Translate value="product_sku" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 150,
      },
      {
        key: 'Product_Name',
        name: <Translate value="product_name" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 150,
      },
      {
        key: 'Post_Date',
        name: <Translate value="posting_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 150,
      },
      {
        key: 'Est_Delivery_Date',
        name: <Translate value="est_delivery" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 150,
      },
      {
        key: 'Quantity',
        name: <Translate value="quantity" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 100,
      },
      {
        key: 'NotShippedQuantity',
        name: <Translate value="not_shipped_quantity" />,
        resizable: true,
        sortable: true,
        filterable: true,
        width: 100,
      },
      {
        key: 'Note',
        name: <Translate value="note" />,
        resizable: true,
        sortable: true,
        filterable: true,
        editable: true,
        width: 200,
      },
    ]

    return (
      <Row>
        <Col>
          <div style={{ maxWidth: '95%', marginLeft: '25px' }} id="trackingNoteModal-dataGrid1">
            <ReactDataGrid
              enableCellSelect={true}
              onGridSort={handleGridSort}
              onAddFilter={handleFilterChange}
              columns={columns}
              rowGetter={rowGetter}
              rowsCount={getSize()}
              minHeight={250}
              rowHeight={25}
              enableRowSelect='single'
              onRowUpdated={handleRowUpdated}
              rowSelection={{
                showCheckbox: true,
                onRowsSelected: onRowsSelected,
                onRowsDeselected: onRowsDeselected,
                selectBy: {
                  isSelectedKey: 'isSelected'
                }
              }}
            />
          </div>
        </Col>
      </Row>
    );
  }

  render() {
    const {
      selectedOrder,
    } = this.state;
    const purchaseOrderNumberStyle = {
      marginLeft: '20px',
      fontSize: '15px',
    }
    const buttonToolbar = {
      marginLeft: '8px',
      marginBottom: '10px',
    }

    return (
      <ContentWrapper>
        <Row>
          <Col style={{ marginBottom: '5px' }}>
            <span style={purchaseOrderNumberStyle}><Translate value="purchase_order_number" />{selectedOrder.order_num}</span>
          </Col>
        </Row>

        <ButtonToolbar style={buttonToolbar}>
          <Button
            bsStyle="primary"
            onClick={(event) => { this.clickNew(event) }}
          >
            <em className="fa fa-plus marginRightStyle" /><Translate value="create" />
          </Button>
          <Button
            bsStyle="success"
            onClick={(event) => { this.updateRows(event) }}
          >
            <em className="fa fa-save marginRightStyle" /><Translate value="save" />
          </Button>
          <Button
            bsStyle="danger"
            onClick={(event) => { this.deleteCategory(event) }}
            disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
          ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
          </Button>
        </ButtonToolbar>

        <Row>
          <Col className="text-center">

            <span>
              {this.renderTrackingNoteTable()}
            </span>

          </Col>
        </Row>

        <NotifyModal 
          title={<Translate value='success' />}
          content={<Translate value='saved_tracking_note' />}
          isVisible={this.state.notifyModalOpen}
          onConfirm={this.closeNotifyModal}
          onCancel={this.closeNotifyModal}
        />
      </ContentWrapper>
    );
  }
}

export default TrackingNoteModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/trackingNoteModal.jsx